import { Map } from 'immutable'

import {
  LOGOUT,
  SET_TOKEN,
  WHO_AM_I,
  AUTH_ERROR,
  AUTH_SUCCESS,
  SET_AUTH_CONFIG,
  VALIDATE_INVITE_LINK,
  VALIDATE_INVITE_LINK_ERROR,
  TYPE_FORM_HEALTHY
} from './actions'

const isFederatedLogin = window.localStorage.getItem('isFederatedLogin')

export const initialState = new Map({
  JWT: window.localStorage.getItem('JWT') || '',
  isFederatedLogin: (isFederatedLogin && JSON.parse(isFederatedLogin)) || '',
  valid: false,
  error: [],
  success: [],
  loaded: false,
  me: {},
  autoLoginEnabled: true,
  typeFormHealthy: null,
  inviteLinkValidation: {
    isValidationTokenDone: false,
    isValidToken: false,
    tokenError: null
  },
  authConfig: {}
})

const authReducer = (state = initialState, action = { type: null }) => {
  switch (action.type) {
    case LOGOUT:
      return state
        .set('JWT', '')
        .set('isFederatedLogin', null)
        .set('valid', false)
        .set('loaded', true)
        .set('me', {})
        .set('autoLoginEnabled', action.data && !action.data.preventAutoLogin)
        .set('error', action.error)
        .set('success', [])
    case SET_TOKEN:
      if (action.data.isFederatedLogin !== undefined) {
        state.set('isFederatedLogin', action.data.isFederatedLogin)
      }
      return state
        .set('JWT', action.data.token)
        .set('loaded', true)
        .set('valid', true)
    case WHO_AM_I:
      return state.set('me', action.data)
    case AUTH_ERROR:
      return state.set('error', action.error).set('success', [])
    case AUTH_SUCCESS:
      return state.set('success', action.success).set('error', [])
    case SET_AUTH_CONFIG:
      return state.set('authConfig', action.data)
    case VALIDATE_INVITE_LINK:
    case VALIDATE_INVITE_LINK_ERROR:
      return state.set('inviteLinkValidation', action.data)
    case TYPE_FORM_HEALTHY:
      return state.set('typeFormHealthy', action.data)
    default:
      return state
  }
}

export default authReducer
